import importer from 'common/importer'
const { genAuthUrl } = importer('NavigationService', null)
const { oktaReq: req, oktaOauthUrl } = importer('APIs', null)
export const getSession = () => {
  return req.get('/sessions/me')
}
export const getSessionWithToken = (sessionToken) => {
  return req.get(`/sessions/${sessionToken}`)
}
export const getSessionUser = () => {
  return req.get('/users/me')
}
export const sessionRefresh = () => {
  return req.get('/sessions/me/lifecycle/refresh')
}
export const logout = (idToken) => {
  const redirect = genAuthUrl('/login')
  return `${oktaOauthUrl}/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${redirect}`
}
